import './BrokerModal.scss'

import React, { Component } from 'react'
import {Button, Modal} from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import ConfirmButton from 'common/views/atoms/ConfirmButton/ConfirmButton'
import { removeBrokerUser } from 'broker/redux/account'


class ConfirmRemoveContact extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleFinish = this.handleFinish.bind(this)
  }

  handleClick() {
    this.props.dispatch(removeBrokerUser(this.props.initialState.id))
    return true
  }

  handleFinish() {
    this.props.handleHide()
  }

  render() {
    return (
      <Modal className="BrokerModal" show={this.props.show}>
          <Modal.Header>
              <Modal.Title>Remove Contact?</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="text">Are you sure you want to remove <a>{(this.props.initialState.first_name ? this.props.initialState.first_name : this.props.initialState.email) + '\'s '}</a>access to your broker portal?</div>
          </Modal.Body>

          <Modal.Footer>
              <Button className="pull-right" onClick={this.props.handleHide}>Cancel</Button>
              <div className="pull-right btn-pad-right"><ConfirmButton onSubmit={this.handleClick} onFinish={this.handleFinish} timeouts={2000} initialText="Yes" pendingText="Sending" completeText="Sent" /></div>
          </Modal.Footer>
      </Modal>
    )
  }
}

const ConfirmRemoveContactModal = connectModal({ name: 'ConfirmRemoveContactModal', destroyOnHide: true })(ConfirmRemoveContact)

export default ConfirmRemoveContactModal
